import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IRecordDeviceMatchV2Body } from './record-device-match-v2-request';
import type { IRecordDeviceMatchV2Response } from './record-device-match-v2-response';
import { recordDeviceMatchV2ResponseSchema } from './record-device-match-v2-response';

export async function recordDeviceMatchV2Api(
  body: IRecordDeviceMatchV2Body,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IRecordDeviceMatchV2Response>> {
  return postRequest<IRecordDeviceMatchV2Response>({
    body,
    options,
    path: '/account/device-match/v2',
    schema: recordDeviceMatchV2ResponseSchema,
  });
}
